import React, { useEffect } from 'react'
import AssessmentModule from '../../../layout/AssessmentModule/AssesmentModule'
import { Route, Routes, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import AlertSaveButton from '../../../button/AlertSaveButton'
import MenuButton from '../../../button/MenuButton'
import {
  updateDevelopmentalRubricDialog,
  updateDevelopmentalRubricForm
} from '../../../../store/actions/developmental-rubrics.actions'
import List from './List/List'
import Gantt from './Gantt/Gantt'
import Create from './Create/Create'
import Preview from './Preview/Preview'
import useYears from '../../../../hooks/setting/useYears'
import Edit from './Edit/Edit'
import GroupedByLearningContinuum from './GroupedByLearningContinuum/GroupedByLearningContinuum'
import useSubjects from '../../../../hooks/subjects/useSubjects'
import { toggleAlertModule } from '../../../../store/actions/alert.actions'
import { updateFilter } from '../../../../store/actions/filter.actions'
import Module from '../../../layout/Module'
import NotFoundPage from '../../../NotFoundPage/NotFoundPage'
import DialogAction from './Dialog/Dialog'
import SelectCurriculum from '../../../SelectCurriculum/SelectCurriculum'

const DevelopmentalRubric = () => {
  const alertSave = useSelector((state) => state?.alert?.save || {})
  const { getYears } = useYears()
  const { getAllSubjects } = useSubjects()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams()
  const curriculumId = params['*']?.split('/')[0]
  const redirectStudentId = params.studentId ? `${params.studentId}/` : ''
  const permissions = useSelector((state) => state?.session?.permissions?.dr || {})
  const preview = useSelector((state) => state?.dr?.preview || null)
  const dialog = useSelector((state) => state?.dr?.dialog)
  const dialogOpen = useSelector((state) => state?.dr?.dialog?.open)

  const onRedirect = (redirectTo, isList) => {
    navigate(`/dashboard/${redirectStudentId}developmental-rubrics/${curriculumId}${redirectTo}`)
    if (isList) {
      dispatch(updateFilter(isList, {}))
    }
  }

  const redirect = (redirectTo, isList) => {
    if (alertSave && alertSave.mode) {
      dispatch(
        toggleAlertModule(true, alertSave.module, alertSave.mode, alertSave.onSave, () => {
          onRedirect(redirectTo, isList)
        })
      )
    } else {
      onRedirect(redirectTo, isList)
    }
  }

  useEffect(() => {
    getYears()
  }, [])
  useEffect(() => {
    getAllSubjects(curriculumId)
  }, [curriculumId])

  const options = []
  if (permissions?.list && curriculumId) {
    options.push({
      id: 'list',
      label: 'Listing developmental rubrics',
      permissions: true,
      href: 'list',
      onClick: () => redirect('', 'dr')
    })
  }

  if (permissions?.['grouped-by-learning-continuum'] && curriculumId) {
    options.push({
      id: 'grouped-by-learning-continuum',
      label: 'Listing learning continuum that are within different developmental rubrics',
      permissions: true,
      href: '/grouped-by-learning-continuum',
      onClick: () => redirect('/grouped-by-learning-continuum', 'drGroupedByLearningContinuum')
    })
  }

  return (
    <AssessmentModule
      title='Developmental Rubric'
      titleLink={`/dashboard/${redirectStudentId}developmental-rubrics`}
      moduleName='dr'
      actions={
        <>
          {permissions['view-gantt-chart'] && curriculumId && (
            <AlertSaveButton
              submodule='Developmental Rubric'
              icon='chart-bar'
              title='Gantt'
              color='secondary'
              onDontSave={() => {
                onRedirect('/gantt')
              }}
            />
          )}
          {curriculumId && (
            <>
              {options.length === 1 ? (
                <AlertSaveButton
                  submodule='Developmental Rubric'
                  icon='th-list'
                  title='List'
                  color='secondary'
                  onDontSave={() => {
                    onRedirect('/list', 'dr')
                  }}
                />
              ) : (
                <MenuButton
                  id='developmental-rubric-list'
                  icon='th-list'
                  title='List'
                  color='secondary'
                  items={options}
                />
              )}
            </>
          )}
          {permissions?.created && curriculumId && (
            <AlertSaveButton
              submodule='Developmental Rubric'
              icon='plus'
              title='Create'
              color='secondary'
              onDontSave={() => {
                dispatch(updateDevelopmentalRubricForm({ curriculumId: curriculumId }))
                onRedirect('/create/step/0')
              }}
            />
          )}
        </>
      }
    >
      <Routes>
        <Route path='/' element={<SelectCurriculum />} />
        <Route index path='/:curriculumId' element={<List />} />
        <Route path='/:curriculumId/gantt' element={<Gantt />} />
        <Route path='/:curriculumId/grouped-by-learning-continuum' element={<GroupedByLearningContinuum />} />
        <Route path='/:curriculumId/create/step/:step' element={<Create />} />
        <Route path='/:curriculumId/edit/:id/step/:step' element={<Edit />} />
        <Route
          path='*'
          element={
            <Module.BodyFullContainer className='flex justify-center items-center'>
              <NotFoundPage />
            </Module.BodyFullContainer>
          }
        />
      </Routes>
      {dialogOpen && (
        <DialogAction
          show={dialogOpen}
          onClose={() => dispatch(updateDevelopmentalRubricDialog())}
          type={dialog.type}
          formData={dialog.form}
          curriculumId={curriculumId}
        />
      )}
      {preview && <Preview curriculumId={curriculumId} />}
    </AssessmentModule>
  )
}

export default DevelopmentalRubric
